import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as moment from 'moment';
import { APIRequest } from '@reverbdotcom/discovery-ui';
import UrlHelpers from '../../../shared/url_helpers';

class OrderNote extends React.Component {
  renderCreatedAt() {
    const parsed = moment.unix(this.props.orderNote.created_at.seconds);
    return parsed.format('lll');
  }

  handleDeleteNote = (event) => {
    event.preventDefault();
    const confirmed = confirm(I18n.t('js.orderNotes.confirmDelete'));
    if (!confirmed) { return; }

    APIRequest.destroy(
      UrlHelpers.deleteOrderNotePath,
      JSON.stringify({
        order_note_ids: [this.props.orderNote.id],
      }),
      { contentType: 'application/json' },
      '4.0',
    );

    this.props.onDeleted(this.props.orderNote);
  }

  render() {
    return (
      <div className="order-note">
        <div className="order-note__header">
          <span className="order-note__timestamp">
            {this.renderCreatedAt()}
          </span>
          <button
            className="order-note__delete"
            type="button"
            onClick={this.handleDeleteNote}
          />
        </div>
        <div className="order-note__body">
          {this.props.orderNote.body}
        </div>
      </div>
    );
  }
}

OrderNote.propTypes = {
  orderNote: PropTypes.object.isRequired,
};

export default OrderNote;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/order_notes/order_note.jsx